export const strings = {
  title: 'フード',
}

export const foodTableContent = [
  '',
  'ID',
  'インデックス',
  'フード名',
  'カテゴリ',
  '画像',
]
